import { useRef, useState, useReducer, useEffect, useContext } from "react";
import SignatureCanvas from "react-signature-canvas";
import { useFollowupUserSignature } from "../../../../Hooks/useFollowupUserSignature";
import { useUpdateMilestone } from "../../../../Hooks/useUpdateMilestone";
import { useFollowupUserQuestions } from "../../../../Hooks/useFollowupUserQuestions";
import WhiteLogo from "../../../../assets/FLPSignConfirm/img/logo-white-1.png";
import "../../../../assets/FLPSignConfirm/scss/Signature_Reconfirm.scss";
import { usePageLoad } from "../../../../Hooks/usePageLoad";
import { getPageName } from "../../../../Constants/PageNames";
import Loa from "../../Layouts/UFC_DC_RF_V1/Loa";
import Tob from "../../Layouts/UFC_DC_RF_V1/Tob";
import Decl from "../../Layouts/UFC_DC_RF_V1/Decl";
import Vq from "../../Layouts/UFC_DC_RF_V1/Vq";
import Dsar from "../../Layouts/UFC_DC_RF_V1/Dsar";
import pdf from "../../../../assets/FLPSignConfirm/img/link_1a.png";
import CheckBox2 from "../../../UI/CheckBox2";
import { useFollowupSignTimeUpdates } from "../../../../Hooks/useFollowupSignTimeUpdates";
import { Api } from "../../../../api/Api";
import VisitorParamsContext from "../../../../Contexts/VisitorParams";
import { useClaimReg } from "../../../../Hooks/useClaimReg";

const initialState = {
    isChecked: false,
    isAgreed: false,
    isCanvasEmpty: false,
    isValid: false,
};
const signatureReducer = (state, action) => {
    switch (action.type) {
        case "signPadChange": {
            return {
                ...state,
                isCanvasEmpty: action.payload.value,
            };
        }
        case "privacyAgreed": {
            return {
                ...state,
                isAgreed: action.payload.value,
            };
        }
        case "validSignature": {
            return {
                ...state,
                isValid: action.payload.value,
            };
        }
        default:
            return state;
    }
};

const Signature = ({ allFollowupData, uuid, removeFromPending, userSign, setUserSign, flp_source,userLender }) => {

    const [state, dispatch] = useReducer(signatureReducer, initialState);
    const { saveFollowupUserSignature, isLoading } = useFollowupUserSignature();
    const { saveFollowupUserQuestions } = useFollowupUserQuestions();
    const [isChecked, setIsChecked] = useState(true);
    const [signatureWrapWidth, setSignatureWrapWidth] = useState(0);
    const [signatureWrapHeight, setSignatureWrapHeight] = useState(0);
    const signatureWrapRef = useRef();
    const [showloa, setShowLoa] = useState(false);
    const [questionPdf, setQuestionPdf] = useState(false);
    const [showTOB, setShowTob] = useState(false);
    const [showDecl, setShowDecl] = useState(false);
    const [showDsar, setShowDsar] = useState(false);
    const signPadRef = useRef();
    const [canvasShow, setCanvasShow] = useState(true);
    const checkboxOneRef = useRef(null);
    console.log("canvasShow", canvasShow);
    const showLoapdf = () => { setShowLoa("show"); };
    const showQuestpdf = () => setQuestionPdf("show");
    const showTobpdf = () => setShowTob("show");
    const showDeclpdf = () => setShowDecl("show");
    const showDsarpdf = () => setShowDsar("show");
    const { saveFollowupUserSignUpdates } = useFollowupSignTimeUpdates();
    const { visitorParameters } = useContext(VisitorParamsContext);
    const { savePageLoad, calledOnce } = usePageLoad();
    const query_string = localStorage.getItem("queryString");
    const splitName = localStorage.getItem("split_name");
    const { updateClaimReg } = useClaimReg();
    const [forceRecalculate, setForceRecalculate] = useState(false);  // Track when to force recalculation
    const divRefFour = useRef(null);
    useEffect(() => {
        if (!!uuid && !calledOnce) {
            const data = {
                uuid,
                page_name: getPageName("flp_sign_reconfirm_signature"),
                status: "visited",
                source: flp_source,
            };
            (async () => {
                await savePageLoad(
                    uuid,
                    data,
                    "visited_status",
                    splitName,
                    query_string,
                    allFollowupData
                );
            })();
        }
    }, [uuid, calledOnce]);

    const handlePageLoad = async () => {
        const data = {
            uuid,
            page_name: getPageName("flp_sign_reconfirm_signature"),
            status: "completed",
            source: flp_source,
        };
        await savePageLoad(
            uuid,
            data,
            "visited_status",
            splitName,
            query_string,
            allFollowupData
        );
    };


    // useEffect(() => {
    //     function handleResize() {
            

    //         setSignatureWrapWidth(signatureWrapRef.current.clientWidth);
    //         setSignatureWrapHeight(signatureWrapRef.current.clientHeight);
    //     }
    //     setSignatureWrapWidth(signatureWrapRef.current.clientWidth);
    //     setSignatureWrapHeight(signatureWrapRef.current.clientHeight);

    //     window.addEventListener("resize", handleResize);
    //     return () => window.removeEventListener("resize", handleResize);
    // }, [canvasShow]);

    const handleResize = () => {
        if (signatureWrapRef.current) {
            const newWidth = signatureWrapRef.current.clientWidth;
            const newHeight = signatureWrapRef.current.clientHeight;

            // Only update dimensions if they have changed
            setSignatureWrapWidth(newWidth);
            setSignatureWrapHeight(newHeight);

            // If width or height is 0, set the flag to force recalculation
            if (newWidth === 0 || newHeight === 0) {
                setForceRecalculate(true);
            }
        }
    };

    useEffect(() => {
        // Initial calculation of dimensions
        handleResize();

        // Add resize event listener
        window.addEventListener("resize", handleResize);

        return () => {
            // Cleanup resize event listener
            window.removeEventListener("resize", handleResize);
        };
    }, [canvasShow, forceRecalculate]);  // Include `forceRecalculate` in dependencies

    useEffect(() => {
        // Force recalculation if dimensions are 0
        if (signatureWrapWidth === 0 || signatureWrapHeight === 0) {
            setForceRecalculate(true);
        } else {
            setForceRecalculate(false);
        }
    }, [signatureWrapWidth, signatureWrapHeight]);




    const clearSign = async () => {
        if (signPadRef.current) signPadRef.current.clear();
        setCanvasShow(false);
        updateClaimReg(uuid, splitName, "flp_edit_signature", flp_source);
        divRefFour.current.scrollIntoView({ behavior: 'smooth', block: 'start' })

    };

    const reclearSign = () => {
        if (signPadRef.current) signPadRef.current.clear();

    };

    useEffect(() => {
        if (!isChecked) {
            dispatch({ type: "privacyAgreed", payload: { value: false } });
        }
        if (isChecked) {
            dispatch({ type: "privacyAgreed", payload: { value: true } });
        }
    }, [isChecked]);



    const confirmSign = async () => {
        if (!isChecked) {
            checkboxOneRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
            return dispatch({ type: "privacyAgreed", payload: { value: false } });
        }
        try {
            await saveFollowupUserSignUpdates("followup_signature_time_update", uuid, allFollowupData,'signaure_reconfirm');
            const responsepdf = Api.get("/api/v1/vaq-pdf-generate?uuid=" + uuid, {});
            updateClaimReg(uuid, splitName, "flp_reconfirm_signature", flp_source);
            handlePageLoad();
            removeFromPending("signature");
        } catch (e) {
            console.warn(e);
        }
    };


    const saveSignature = async (e) => {
        if (!isChecked) {
            checkboxOneRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
            return dispatch({ type: "privacyAgreed", payload: { value: false } });
        }
        try {
            e.preventDefault();
            const signPad = signPadRef.current;
            if (signPad.isEmpty()) {
                return dispatch({ type: "signPadChange", payload: { value: true } });
            }
            const rpdata = signPad.toData();
            let signLength = 0;
            for (let i = 0; i < rpdata.length; i++) {
                signLength += Object.keys(rpdata[i]).length;
            }
            if (signLength > 13) {
                const canvasDataURL = signPadRef.current
                    .getCanvas()
                    .toDataURL("image/png");
                const response = await saveFollowupUserSignature(
                    canvasDataURL,
                    allFollowupData,
                    "followup_reconfirmed_updated_signature"
                );
                updateClaimReg(uuid, splitName, "flp_submit_signature", flp_source);

                if (response.data.status === "Success") {
                    try {
                         Api.get(
                            "/api/v1/vaq-pdf-generate?uuid=" +
                            visitorParameters.visitor_parameters.uuid,
                            {}
                        );

                        setUserSign(canvasDataURL);
                        removeFromPending("signature");
                        handlePageLoad();

                    } catch (e) {
                        console.warn(e);
                    } finally {
                        console.log("signature retake success");
                        removeFromPending("signature");
                        setUserSign(canvasDataURL);
                    }
                }
            } else {
                return dispatch({ type: "validSignature", payload: { value: true } });
            }
        } catch (e) {
            console.warn(e);
        }
    };



    return (
        <>
            <div className="flp_tmsversion_signature tmsversion_signature">
                <header className="d-none d-lg-block">
                    <div className="container">
                        <div className="row">
                            <div className="logo-part col-lg-12 col-md-12 col-12  text-center">
                                <img src={WhiteLogo} alt="" />
                            </div>
                            <div className="col-lg-6 offset-lg-2 col-md-8 col-12 text-center d-none d-md-block " />
                        </div>
                    </div>
                </header>
                <section className="signature-section">
                    <div className="container ">
                        <div className="row ">
                            <div className="offset-lg-2 col-lg-8 col-12 sign-question">
                                <h2>
                                    <span>IMPORTANT</span> <br /> Your complaint against {userLender} appears valid, and we're prepared to help you pursue it
                                    further. We ask all clients to confirm their signature and ensure
                                    they've read our subsequent documents.{" "}
                                </h2>
                                <div className="offset-lg-2 col-lg-8 col-12">
                                    <ul className="head-ul">
                                        <li> Sign using your finger, mouse or stylus</li>
                                        <li> Keep it fully contained within the box</li>
                                        <li> Ensure it is a true likeness of your signature</li>
                                    </ul>
                                </div>
                               <div ref={divRefFour}></div> 
                                <div
                                    className={`sign-div ${canvasShow ? "hide" : "show"}`}
                                >
                                    <form >
                                        <div className="form-group" >
                                            <div className="signature_canvaseWrap">
                                                <div className="signature-pad anim_bt d-lg-block web-canvas" ref={signatureWrapRef}> 
                                                        <SignatureCanvas
                                                            canvasProps={{
                                                                id: "myID",
                                                                width: signatureWrapWidth,
                                                                height: signatureWrapHeight,
                                                            }}
                                                            ref={signPadRef}
                                                            defaultValue={userSign}
                                                            onEnd={() => {
                                                                if (!signPadRef.current.isEmpty()) {
                                                                    dispatch({
                                                                        type: "signPadChange",
                                                                        payload: { value: false },
                                                                    });
                                                                    dispatch({
                                                                        type: "validSignature",
                                                                        payload: { value: false },
                                                                    });
                                                                }
                                                            }}
                                                        />
                                                </div>
                                            </div>
                                        </div>


                                        {state.isCanvasEmpty && (
                                            <div
                                                className="sign_msg col-12 text-center sign_msg mb-3"
                                                id="signatures_required"
                                            >
                                                Signature is required!
                                            </div>
                                        )}
                                        {state.isValid && (
                                            <div
                                                className="sign_msg col-12 text-center sign_msg"
                                                id="signatures_valid"
                                            >
                                                Draw valid signature!
                                            </div>
                                        )}
                                        <div className="form-check my-3 checkbox-div" ref={checkboxOneRef}>
                                            <CheckBox2
                                                dataId="accepttermsq"
                                                anchorText=""
                                                anchorStyle=""
                                                href=""
                                                onChange={() => {
                                                    setIsChecked(!isChecked);
                                                    dispatch({
                                                        type: "privacyAgreed",
                                                        payload: { value: isChecked },
                                                    });
                                                }}
                                                className="form-check-input checkbox"
                                                labelClassName="form-check-label sign-custom-control-label"
                                                value={isChecked}
                                                checked={isChecked}
                                                CheckBoxText={
                                                    <>
                                                        By clicking submit you agree to us appending your electronic
                                                        signature to the claim documents and confirming that you
                                                        accept the terms of this contract for TMS Legal to represent
                                                        you in your irresponsible Lending claim, and that you agree
                                                        to pay us 45% commission if the claim is successful..
                                                    </>
                                                }
                                            />
                                            {state.isAgreed === false && (
                                                <span className="error_msg text-center">
                                                    Please tick to show your authorisation for us to proceed
                                                </span>
                                            )}
                                            <p className="pt-3">
                                                Preview your unsigned documents before signing above:
                                            </p>

                                            <ul className="list-1a">
                                                <li>

                                                    <a onClick={showLoapdf}>
                                                        <img src={pdf} alt="PDF" /> Letter of Authority
                                                    </a>
                                                </li>
                                                <li>
                                                    <a onClick={showTobpdf}>
                                                        <img src={pdf} alt="" /> Terms of Business
                                                    </a>
                                                </li>
                                                <li>
                                                    <a onClick={showQuestpdf}>
                                                        <img src={pdf} alt="" /> Questionnaire
                                                    </a>
                                                </li>
                                                <li>
                                                    <a onClick={showDeclpdf}>
                                                        <img src={pdf} />
                                                        Declaration Form
                                                    </a>
                                                </li>
                                                <li>
                                                    <a onClick={showDsarpdf}>
                                                        <img src={pdf} />
                                                        DSAR Letter of Authority
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="button-sticky">
                                            <input
                                                type="button"
                                                id="clearbutton"
                                                name="clearbutton"
                                                className="btn-clear clear_bg"
                                                Value="clear"
                                                onClick={reclearSign}
                                            />
                                            <input
                                                className="btn btn-submit slide8"
                                                type="button"
                                                name="submitbutton"
                                                onClick={saveSignature}
                                                Value="Submit"
                                            />
                                        </div>
                                    </form>
                                </div>
                                <div
                                    className={`sign-div ${canvasShow ? "show" : "hide"}`}
                                >
                                    <form >
                                        <div className="form-group">
                                            <div className="signature_canvaseWrap">
                                                <div className="signature-pad anim_bt d-lg-block web-canvas">

                                                    <div id="preview" className="web-canvas text-center">
                                                        <img width="300" height="200" src={userSign} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-check my-3 checkbox-div" ref={checkboxOneRef}>
                                            <CheckBox2
                                                dataId="accepttermsq"
                                                anchorText=""
                                                anchorStyle=""
                                                href=""
                                                onChange={() => {
                                                    setIsChecked(!isChecked);
                                                    dispatch({
                                                        type: "privacyAgreed",
                                                        payload: { value: isChecked },
                                                    });
                                                }}
                                                className="form-check-input checkbox"
                                                labelClassName="form-check-label sign-custom-control-label"
                                                value={isChecked}
                                                checked={isChecked}
                                                CheckBoxText={
                                                    <>
                                                        By clicking submit you agree to us appending your electronic
                                                        signature to the claim documents and confirming that you
                                                        accept the terms of this contract for TMS Legal to represent
                                                        you in your irresponsible Lending claim, and that you agree
                                                        to pay us 45% commission if the claim is successful..
                                                    </>
                                                }
                                            />
                                            {state.isAgreed === false && (
                                                <span className="error_msg text-center mt-1 mb-1">
                                                    Please tick to show your authorisation for us to proceed
                                                </span>
                                            )}
                                            <p className="pt-3">
                                                Preview your unsigned documents before signing above:
                                            </p>

                                            <ul className="list-1a">
                                                <li>

                                                    <a onClick={showLoapdf}>
                                                        <img src={pdf} alt="PDF" /> Letter of Authority
                                                    </a>
                                                </li>
                                                <li>
                                                    <a onClick={showTobpdf}>
                                                        <img src={pdf} alt="" /> Terms of Business
                                                    </a>
                                                </li>
                                                <li>
                                                    <a onClick={showQuestpdf}>
                                                        <img src={pdf} alt="" /> Questionnaire
                                                    </a>
                                                </li>
                                                <li>
                                                    <a onClick={showDeclpdf}>
                                                        <img src={pdf} />
                                                        Declaration Form
                                                    </a>
                                                </li>
                                                <li>
                                                    <a onClick={showDsarpdf}>
                                                        <img src={pdf} />
                                                        DSAR Letter of Authority
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="button-sticky">
                                            <input
                                                type="button"
                                                id="clearbutton"
                                                name="clearbutton"
                                                className="btn-clear"
                                                Value="Edit"
                                                onClick={clearSign}
                                            />
                                            <input
                                                className="btn btn-submit slide8"
                                                type="button"
                                                name="submitbutton"
                                                Value="Submit"
                                                onClick={confirmSign}
                                            />
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </section >
                <footer>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <p>
                                    TMS Legal Ltd is a limited company registered in England and Wales
                                    under company no: 10315962 Its registered office is Arena, 9 Nimrod
                                    Way, Ferndown, BH21 7UH It is authorised and regulated by the
                                    Solicitors Regulation Authority, Number: 645041
                                </p>
                                <p>Copyright © 2022 TMS Legal Ltd - All rights reserved</p>
                            </div>
                        </div>
                    </div>
                </footer>
            </div >
            {showloa && <Loa setShowLoa={setShowLoa} showloa={showloa} />}

            {
                questionPdf && (
                    <Vq close={() => setQuestionPdf(false)} />
                )
            }

            {showTOB && <Tob showTOB={showTOB} setShowTob={setShowTob} />}
            {showDecl && <Decl showDecl={showDecl} setShowDecl={setShowDecl} />}

            {showDsar && <Dsar showDsar={showDsar} setShowDsar={setShowDsar} />}
        </>

    );

}
export default Signature;